import styled from '@emotion/styled';
import { css } from 'theme-ui';
import pxToRem from '../../utils/pixelsToRem';

export const TitleMain = styled.h1(
  css({
    textTransform: 'capitalize',
    fontSize: 5,
    fontWeight: '700',
    mb: 3,
  }),
);

export const TitleSecondary = styled.h2(
  css({
    textTransform: 'capitalize',
    fontSize: 4,
    fontWeight: '600',
  }),
);

export const TitleTertiary = styled.h3(
  css({
    textTransform: 'capitalize',
    fontSize: 3,
    fontWeight: '500',
  }),
);

export const SectionTitle = styled.h2(
  css({
    textTransform: 'capitalize',
    fontSize: 4,
    fontWeight: 'medium',
    borderBottom: '2px black solid',
    lineHeight: 1.5,
    overflow: 'hidden',
  }),
);

export const DetailPageTitle = styled.h1(
  css({
    fontFamily: "'Urbanist'",
    fontWeight: '200',
    fontSize: pxToRem(40),
    lineHeight: pxToRem(48),
    letterSpacing: '0.03em',
  }),
);
